import Component from "@tunnel-components/@sharded/inhibitions/created/component";
import * as React from "react";
import { connect } from "react-redux";
import * as Lodash from "lodash";
import * as moment from "moment";

import {
  ExtractorCameraListActionCreator,
  SystemSettingsActionCreator,
  IncidentTypesLoadedActionCreator,
  IncidentInhibateLocalLoadedActionCreator,
  IncidentInhibateLocalCreatedByCameraActionCreator,
  IncidentInhibateLocalCreatedBySectionActionCreator,
  CameraBySectionLoadedActionCreator,
} from "@tunnel-store/index";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name onSelectFirstCamera
 * @name onChoiceCamera
 * @name onSelectCamera
 * @name onChangeName
 * @name onChangeNameRadio
 * @name onStartDateChange
 * @name onEndDateChange
 * @name onChange
 * @name componentWillUnmount
 * @name componentWillReceiveProps
 * @name render
 * @infos "https://reactjs.org"
 */

class Container extends React.Component<any, any> {
  //  faire cette action toute les 2000 millisecondes
  public debouceSubmit = Lodash.debounce(() => {
    this.props.IncidentInhibateLocalCreatedByCameraActionCreator(this.state);
  }, 2000);
  //  faire cette action toute les 550 millisecondes
  public debounceChangeNameRadio = Lodash.debounce((param: any, event: any) => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState({
      cameraFirstSelect: false,
      error: false,
      perimetre: false,
      faillure: false,
    });
    /**
     * @constant
     * @name radio
     * @type any[]
     */
    const radio: any[] = this.state.radio;
    {
      /** boucle */
    }

    for (let i = 0; i < Math.ceil(this.props.SectionData.length); i++) {
      radio[i] = false;
    }

    radio[param] = true;

    const radioId: any[] = this.state.radioId;

    radioId[0] = { id: Number(event.target.id.split("-")[1]) };

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => radio);
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => radioId);
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      camera: false,
      cameraArray: [null, null],
    }));
  }, 50);
  //  faire cette action toute les 550 millisecondes
  public debounceChangeName = Lodash.debounce((param: any, event: any) => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      error: false,
      perimetre: false,
      faillure: false,
    }));
    /**
     * @constant
     * @description :
     * @name checkedItems
     * @type any[]
     */
    const checkedItems: any[] = this.state.checkedItems;
    /**
     * @constant
     * @description :
     * @name incidenTypeId
     * @type any[]
     */
    const incidenTypeId: any[] = this.state.incidenTypeId;

    checkedItems[param] = !this.state.checkedItems[param];

    if (checkedItems[param]) {
      incidenTypeId[param] = { id: Number(event.target.id) };
    } else {
      incidenTypeId[param] = null;
    }
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => incidenTypeId);
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => checkedItems);
  }, 50);
  //  faire cette action toute les 550 millisecondes
  public debounceSelectFirstCamera = Lodash.debounce((value: any) => {
    {
      /** Vérification de l'existence d'une variable */
    }
    if (!Lodash.isUndefined(value)) {
      {
        /** Vérification de l'existence d'une variable */
      }
      if (value.includes("-")) {
        const cameraArray: object[] = this.state.cameraArray;
        const idCamera: number = Number(value.split("-")[0]);
        const idsection: number = Number(value.split("-")[1]);

        cameraArray[0] = { id: Number(idCamera) };

        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ cameraArray }));

        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ cameraFirstSelect: true }));

        this.props.CameraBySectionLoadedActionCreator(Number(idsection));
      } else {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ cameraFirstSelect: false }));
      }
    }
  }, 50);
  //  faire cette action toute les 550 millisecondes
  public debounceSelectCamera = Lodash.debounce((value: any) => {
    {
      /** Vérification de l'existence d'une variable */
    }

    if (!Lodash.isEqual(value, "eudes")) {
      /**
       * @constant
       * @name cameraArray
       * @type any[]
       */
      const cameraArray: any[] = this.state.cameraArray;

      cameraArray[1] = { id: Number(value) };

      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ cameraArray, perimetre: false }));
    }
  }, 50);
  //  faire cette action toute les 550 millisecondes
  public debounceChoiceCamera = Lodash.debounce(() => {
    /**
     * @constant
     * @name radio
     * @type any[]
     */
    const radio: any[] = this.state.radio;
    /**
     * @constant
     * @name radioId
     * @type any[]
     */
    const radioId: any[] = this.state.radioId;

    {
      /** boucle */
    }
    for (let i = 0; i < Math.ceil(this.props.SectionData.length); i++) {
      radio[i] = false;
    }
    radioId[0] = null;

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => radioId);
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => radio);
  }, 50);

  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { object }               state
     * @property { string }               state.action
     * @property { <number|string> }      state.notification
     */
    this.state = {
      btnloading: false,
      camera: false,
      cameraArray: [],
      cameraFirstSelect: false,
      checkedItems: [],
      error: false,
      faillure: false,
      incidenTypeId: [],
      radio: [],
      radioId: [],
      selectedCameraEnd: "",
      selectedCameraStart: "",
      spinner: false,
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque
     * initialisation des composants "seulement quand il y'a un event
     * exécuté"
     */
    this.onEndDateChange = this.onEndDateChange.bind(this);
    this.onStartDateChange = this.onStartDateChange.bind(this);
    this.onChangeName = this.onChangeName.bind(this);
    this.onChoiceCamera = this.onChoiceCamera.bind(this);
    this.onSelectFirstCamera = this.onSelectFirstCamera.bind(this);
    this.onSelectCamera = this.onSelectCamera.bind(this);
    this.onChangeNameRadio = this.onChangeNameRadio.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }
  /**
   * Selection des caméras
   * @method onSelectFirstCamera
   * @param { any } value
   * @infos "https://cyclope.ai"
   */
  public onSelectFirstCamera = (value: any): void => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState({ error: false, faillure: false });
    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    this.debounceSelectFirstCamera(value);
  };
  /**
   * Selection des caméras
   * @method onChoiceCamera
   * @param { any } event
   * @infos "https://cyclope.ai"
   */
  public onChoiceCamera = (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.persist();

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      camera: true,
      error: false,
      faillure: false,
    }));
    {
      /** Empêcher la mutation du state */
    }

    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    this.debounceChoiceCamera();
  };
  /**
   * Selection des caméras
   * @method onSelectCamera
   * @param { any } value
   * @infos "https://cyclope.ai"
   */
  public onSelectCamera = (value: any) => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ error: false, faillure: false }));
    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    this.debounceSelectCamera(value);
  };

  /**
   * Manipulation des dates avec le date-picker
   * @external react-datepicker
   * @method onStartDateChange
   * @param { any }  event
   * @infos "https://reactdatepicker.com/"
   */
  public onStartDateChange = (value: any) => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ error: false, spinner: false }));
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ startDate: value }));
  };

  /**
   * Manipulation des dates avec le date-picker
   * @external react-datepicker
   * @method onEndDateChange
   * @param { any }  event
   * @infos "https://reactdatepicker.com/"
   */
  public onEndDateChange = (value: any) => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState({ error: false, faillure: false });
    {
      /** Empêcher la mutation du state */
    }
    this.setState({ endDate: value });
  };
  /**
   * Manipulation et envoie des data
   * @method onSubmit
   * @param { any }  event
   * @infos "https://cyclope.ai"
   */
  public onSubmit = (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.persist();
    {
      /** Vérification de l'existence d'une variable */
    }
    if (
      !Lodash.isNull(this.state.startDate) &&
      !Lodash.isNull(this.state.endDate) &&
      !Lodash.isEmpty(this.state.startDate) &&
      !Lodash.isEmpty(this.state.endDate) &&
      moment(this.state.startDate) < moment(this.state.endDate)
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        faillure: false,
        perimetre: false,
        error: false,
      }));
      // setTimeOut

      /**
       * @constant
       * @name cameraEmpty
       * @type boolean
       */
      const cameraEmpty: boolean = Lodash.isEmpty(
        this.state.cameraArray.filter((elem: any) => elem !== null)
      );
      /**
       * @constant
       * @name sectionEmpty
       * @type boolean
       */

      const sectionEmpty: boolean = Lodash.isEmpty(
        this.state.radioId.filter((elem: any) => elem !== null)
      );
      {
        /** vérification  */
      }
      if (cameraEmpty && sectionEmpty) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          perimetre: true,
          faillure: false,
          error: false,
          spinner: false,
        }));
      } else {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          faillure: false,
          perimetre: false,
          error: false,
          spinner: true,
        }));

        /**
         * Afin d'améliorer la performance de l'interface on utilise des actions
         * espacé dans le temps
         */
        this.debouceSubmit();
      }
    } else {
      this.setState((state: any): any => ({
        error: true,
        faillure: false,
        perimetre: false,
        spinner: false,
      }));
    }
  };
  /**
   * Manipulation des inputs
   * @public
   * @method onChangeName
   * @param { any } event
   * @param { number } param
   * @infos "https://cyclope.ai"
   */
  public onChangeName = (param: number) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    // Faire persister mon événement
    event.persist();
    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    this.debounceChangeName(param, event);
  };
  /**
   * Manipulation des inputs
   * @public
   * @method onChangeNameRadio
   * @param { any } event
   * @param { any } param
   * @infos "https://cyclope.ai"
   */
  public onChangeNameRadio = (param: any) => (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    // Faire persister mon événement
    event.persist();
    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    this.debounceChangeNameRadio(param, event);
  };

  /**
   * Cycle de vie d'un composant react
   * @method componentWillUnmount
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      btnLoading: false,
      camera: false,
      cameraArray: [null, null],
      cameraFirstSelect: false,
      checkedItems: [],
      error: false,
      faillure: false,
      incidenTypeId: [],
      perimetre: false,
      radio: [],
      radioId: [],
      selectedCameraEnd: "",
      selectedCameraStart: "",
      spinner: false,
      // selectedOptionsFirstCamera:null,
      // selectedOptionsSecondCamera:null,
    }));

    // Stopper l'action une fois le component détruit
    this.debounceChangeNameRadio.cancel();
    // Stopper l'action une fois le component détruit
    this.debounceChangeName.cancel();
    // Stopper l'action une fois le component détruit
    this.debounceSelectFirstCamera.cancel();
    // Stopper l'action une fois le component détruit
    this.debounceSelectCamera.cancel();

    // Stopper l'action une fois le component détruit
    this.debounceChoiceCamera.cancel();
    // Stopper l'action une fois le component détruit
    this.debouceSubmit.cancel();
  }

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    {
      /** Appel des actions  */
    }
    this.props.ExtractorCameraListActionCreator(); // la liste des caméras
    this.props.SystemSettingsActionCreator(); //  la liste des sections ( pas d'intertube )
    this.props.IncidentTypesLoadedActionCreator(); // la liste des types d'incidents
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** Comparaison */
    }
    if (nextProps.cameraList !== this.props.cameraList) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(nextProps.cameraList)) {
        this.setState((state: any): any => ({
          selectedOptionsFirstCamera: nextProps.cameraList,
        }));
      }
    } else if (nextProps.sectionCameras !== this.props.sectionCameras) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(nextProps.sectionCameras)) {
        this.setState((state: any): any => ({
          selectedOptionsSecondCamera: nextProps.sectionCameras,
        }));
      }
    } else if (nextProps.inhibitionCreated !== this.props.inhibitionCreated) {
      if (!Lodash.isUndefined(nextProps.inhibitionCreated)) {
        this.props.IncidentInhibateLocalLoadedActionCreator();
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          faillure: false,
          perimetre: false,
          spinner: false,
          endDate: "",
          cameraFirstSelect: false,
          startDate: "",
          cameraArray: [],
        }));
      }
    } else if (nextProps.faillureCreated !== this.props.faillureCreated) {
      if (!Lodash.isUndefined(nextProps.faillureCreated)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          faillure: true,
          spinner: false,
          perimetre: false,
        }));
      }
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentDidUpdate
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } prevProps
   * @param { any } prevState
   * @infos "https://reactjs.org"
   */
  public componentDidUpdate(prevProps: any, prevState: any) {
    {
      /** Comparaison des props */
    }
    if (prevState.checkedItems !== this.state.checkedItems) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        checkedItems: state.checkedItems,
      }));
    } else if (prevState.incidenTypeId !== this.state.incidenTypeId) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        incidenTypeId: state.incidenTypeId,
      }));
    } else if (prevState.radio !== this.state.radio) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ radio: state.radio }));
    } else if (prevState.radioId !== this.state.radioId) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ radioId: state.radioId }));
    } else if (prevProps.isVisible !== this.props.isVisible) {
      if (this.props.isVisible === false) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          btnLoading: false,
          camera: false,
          cameraArray: [null, null],
          cameraFirstSelect: false,
          checkedItems: [],
          error: false,
          faillure: false,
          incidenTypeId: [],
          perimetre: false,
          radio: [],
          radioId: [],
          selectedCameraEnd: "",
          selectedCameraStart: "",
          spinner: false,
          // selectedOptionsFirstCamera:null,
          // selectedOptionsSecondCamera:null,
        }));

        // Stopper l'action une fois le component détruit
        this.debounceChangeNameRadio.cancel();
        // Stopper l'action une fois le component détruit
        this.debounceChangeName.cancel();
        // Stopper l'action une fois le component détruit
        this.debounceSelectFirstCamera.cancel();
        // Stopper l'action une fois le component détruit
        this.debounceSelectCamera.cancel();
        // Stopper l'action une fois le component détruit
        this.debounceChoiceCamera.cancel();
        // Stopper l'action une fois le component détruit
        this.debouceSubmit.cancel();
      }
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return (
      <Component
        {...this.props}
        {...this.state}
        onChangeName={this.onChangeName}
        onSubmit={this.onSubmit}
        onChangeNameRadio={this.onChangeNameRadio}
        onStartDateChange={this.onStartDateChange}
        onEndDateChange={this.onEndDateChange}
        onSelectCamera={this.onSelectCamera}
        onChoiceCamera={this.onChoiceCamera}
        onSelectFirstCamera={this.onSelectFirstCamera}
      />
    );
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {
    IncidentTypeData: state.IncidentTypesLoaded.data,
    inhibitionCreated: state.IncidentInhibateLocalCreated.data,
    SectionData: state.SystemSettings.data,
    cameraList: state.ExtractorCameraList.data,
    faillureCreated: state.IncidentInhibateLocalCreated.error,
    sectionCameras: state.CameraBySection.data,
  };
}

export default connect(mapStateToProps, {
  CameraBySectionLoadedActionCreator,
  IncidentInhibateLocalLoadedActionCreator,
  ExtractorCameraListActionCreator,
  SystemSettingsActionCreator,
  IncidentTypesLoadedActionCreator,
  IncidentInhibateLocalCreatedByCameraActionCreator,
  IncidentInhibateLocalCreatedBySectionActionCreator,
})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/inhibitions/created/container.tsx